import { render, staticRenderFns } from "./EditStoreApprove.vue?vue&type=template&id=1b35edd2"
import script from "./EditStoreApprove.vue?vue&type=script&lang=js"
export * from "./EditStoreApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports